export default function (formId, errorMessage = 'Selecteer een optie in boven staande lijst om door te kunnen gaan.') {
  const form = typeof formId === 'string' ? document.getElementById(formId) : formId;
  if (!form) {
    console.warn('block invalid custom select, element not found with ID: ', formId);
    return;
  }
  const submitButtons = form.querySelectorAll('button:not([type]),button[type="submit"],input[type="submit"]');
  const checkValidity = event => {
    if (form.checkValidity()) {
      return;
    }

    // Check if the reason is any custom input selects.
    const inputs = form.querySelectorAll('input[name][required][type="radio"]');
    const inputHasValueByName = {};
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      const inputName = input.getAttribute('name');
      if (inputHasValueByName[inputName]) {
        continue;
      }
      inputHasValueByName[inputName] = input.checked;
    }
    const inputNames = Object.keys(inputHasValueByName);
    let missingValue = false;
    for (let i = 0; i < inputNames.length; i++) {
      const inputName = inputNames[i];
      const hasValue = inputHasValueByName[inputName];
      if (!hasValue) {
        missingValue = true;

        // Fire of event on the input select that shows an alert.
        let input = form.querySelector('input[name="' + inputName + '"][type="radio"]');
        if (!input) {
          continue;
        }
        const group = input.closest('.form-group');
        if (!group) {
          continue;
        }
        group.dispatchEvent(new CustomEvent('nc:set-invalid', {
          detail: {
            target: group,
            contents: errorMessage
          }
        }));
      }
    }
    // Prevent the form from being submitted.
    if (missingValue) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  // The buttons are checked as well since this prevents errors being logged to the console.
  for (let i = 0; i < submitButtons.length; i++) {
    submitButtons[i].addEventListener('click', checkValidity);
  }
  form.addEventListener('submit', checkValidity);
}